import MUIContainer from '@/components/MUI-Components/MUI-Container';
import DisplayImage from '@/components/Ui-components/display-image';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import Box from '@mui/material/Box';

const Achievement = (props: any) => {
    const {heading, subheading, rewardData, rewardItemSx} = props;
    return (
        <Grid xs={12} item>
            <MUIContainer>
                <Box className="spectrum-header-wrapper ">
                    <Typography className="spectrum-heading color-black" component="h3">
                        {heading}
                    </Typography>
                    <Box className="divder-wrapper">
                        <hr className="divider-line" />
                    </Box>
                    <Box className="sub-heading-box ">
                        <Typography className="spectrum-sub-heading color-black">{subheading}</Typography>
                    </Box>
                </Box>
                <Grid container spacing={2}>
                    {rewardData?.map((item: any, index: number) => (
                        <Grid item md={2} sm={4} xs={6} key={index} className="reward-img-container" sx={rewardItemSx}>
                            <DisplayImage src={item?.src} alt={item?.alt} width={150} />
                        </Grid>
                    ))}
                </Grid>
            </MUIContainer>
        </Grid>
    );
};

export default memo(Achievement);
